import React from 'react';
import { Table } from 'antd';
import { formatBytes } from '../hooks/use_debug_data';
function renderConsistency(record, consistency) {
    if (!consistency)
        return '—';
    if (record.name === 'contact') {
        return consistency.contactMatch ? React.createElement("span", { style: { color: '#52c41a' } }, "\u2705 \u4E00\u81F4") : React.createElement("span", { style: { color: '#faad14' } },
            "\u26A0\uFE0F \u5DEE ",
            consistency.contactDiff,
            " \u6761");
    }
    if (record.name === 'org') {
        return consistency.orgMatch ? React.createElement("span", { style: { color: '#52c41a' } }, "\u2705 \u4E00\u81F4") : React.createElement("span", { style: { color: '#faad14' } },
            "\u26A0\uFE0F \u5DEE ",
            consistency.orgDiff,
            " \u6761");
    }
    return '—';
}
const LokiStatsSection = ({ lokiStats, consistency, loading }) => {
    var _a;
    const columns = [
        {
            title: '集合名',
            dataIndex: 'name',
            key: 'name',
            width: 160,
            render: (name) => React.createElement("code", null, name),
        },
        {
            title: '记录数',
            dataIndex: 'count',
            key: 'count',
            width: 100,
            align: 'right',
            render: (v) => v.toLocaleString(),
        },
        {
            title: '占用大小',
            dataIndex: 'sizeBytes',
            key: 'sizeBytes',
            width: 120,
            render: (bytes) => formatBytes(bytes),
        },
        {
            title: '与Dexie一致性',
            key: 'consistency',
            width: 160,
            render: (_, record) => renderConsistency(record, consistency),
        },
    ];
    const hasData = lokiStats && lokiStats.tables.length > 0;
    return (React.createElement("div", null,
        !hasData && !loading && React.createElement("div", { style: { padding: '16px 0', color: '#999', textAlign: 'center' } }, "Loki \u7EDF\u8BA1\u4E0D\u53EF\u7528"),
        (hasData || loading) && (React.createElement(Table, { columns: columns, dataSource: (_a = lokiStats === null || lokiStats === void 0 ? void 0 : lokiStats.tables) !== null && _a !== void 0 ? _a : [], rowKey: "name", pagination: false, size: "small", loading: loading, footer: () => lokiStats ? (React.createElement("div", { style: { textAlign: 'right', color: '#666' } },
                "\u603B\u5927\u5C0F: ",
                React.createElement("strong", null, formatBytes(lokiStats.totalSizeBytes)))) : null }))));
};
export default LokiStatsSection;
